import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

/**
 * Clase encargada de crear las filas para la edicion
 */
class TableRowEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limite: props.limite,
            seleccionarTodasAsig: false,
            limiteCompraTotal: props.limiteCompraTotal,
            limiteCompraTotalSinAsignar: props.limiteCompraTotal - props.limite,
            mensajeError: false
        };

        this.onSeleccionarTodasAsingChange = this.onSeleccionarTodasAsingChange.bind(this);
    }
    /**
     * Maneja el cambio de estado del input cuando cambia el limite
     * @param {any} event Objeto de tipo event con los atributos del evento generado por la accion de elemento
     */
    onInputChange(event) {
        let value = event.target.value;
        if (value == "" || value == ".") {
            this.setState({ limite: ""/*, limiteCompraTotalSinAsignar: diferenciaLimiteCompra*/ });
        } else {
            if (/^((\d{0,2})(\.(\d{0,2}))?)$/g.test(value)) {
                let asdas = value.substring(value.length - 1, value.length);
                let valueFloat = GlobalHelper.ParseFloat(value);
                if (asdas == ".") {
                    if (valueFloat >= 0 && valueFloat <= 100 || this.props.modalidadDistribucionLimiteId == 2) {
                        this.setState({ limite: value/*, limiteCompraTotalSinAsignar: diferenciaLimiteCompra*/ });
                    }
                } else {
                    if (valueFloat >= 0 && valueFloat <= 100 || this.props.modalidadDistribucionLimiteId == 2) {
                        this.setState({ limite: valueFloat/*, limiteCompraTotalSinAsignar: diferenciaLimiteCompra*/ });
                    }
                }
            }
        }
    }
    /**
     * Maneja el cambio de estado para asignar o desasignar los valores a todas las tarjetas
     * @param {any} event Objeto de tipo event con los atributos del evento generado por la accion de elemento
     */
    onSeleccionarTodasAsingChange(event) {
        this.setState({ seleccionarTodasAsig: event.target.checked });
    }
    /**
     * 
     */
    actualizarEstadoDeLimites(tarjetaId, limite, seleccionarTodasAsig, cuentaId) {
        //this.setState({

        //}, this.props.cambiarLimite(tarjetaId, limite, seleccionarTodasAsig, cuentaId));
    }

    render() {
        const { modalidadDistribucionLimiteId } = this.props;

        return (
            <div className="col-xs-8">
                <div className="row" >
                    <div className={"col-xs-" + ((modalidadDistribucionLimiteId == 2) ? "6" : "2") + " no-padding"}>
                        <div className="row" >
                            <div className={"col-xs-" + ((modalidadDistribucionLimiteId == 2) ? "4" : "12")}>
                                <div className="row">
                                    <div className="col-xs-8 no-padding-right">
                                        <input type="text" value={this.state.limite} className="form-control default-input"
                                            onChange={(event) => this.onInputChange(event)} />
                                    </div>
                                    <div className="col-xs-4 no-padding-right">
                                        <label className="label-secondary">%</label>
                                    </div>
                                </div>
                            </div>
                            {(modalidadDistribucionLimiteId == 2) &&
                                <div className="col-xs-6">
                                    <span><input type="checkbox" value={this.state.seleccionarTodasAsig}
                                        onChange={this.onSeleccionarTodasAsingChange} />
                                        Asignar el mismo a todas</span>
                                </div>}
                        </div>
                    </div>
                    <div className="col-xs-4">
                        <div className="row">
                            <div className="col-xs-6">
                                <GenericSimpleButton text="Listo" buttonClass="btn btn-cta"
                                    onClick={() => {
                                        if (this.props.limiteAnterior != this.state.limite) {
                                            if (modalidadDistribucionLimiteId == 2) {
                                                if ((this.state.limiteCompraTotalSinAsignar + this.state.limite) <= 100) {
                                                    this.setState({ mensajeError: false },
                                                        this.props.cambiarLimite(this.props.tarjetaId,
                                                            this.state.limite,
                                                            this.state.seleccionarTodasAsig,
                                                            this.props.cuentaId));
                                                    this.props.mostrarMensajeLimitesIguales(false);
                                                } else {
                                                    this.setState({ mensajeError: true});
                                                    this.props.mostrarMensajeLimitesIguales(false);
                                                }
                                            } else {
                                                this.props.cambiarLimite(this.props.tarjetaId, this.state.limite, this.state.seleccionarTodasAsig, this.props.cuentaId);
                                            }
                                        }
                                        else {
                                            this.props.mostrarMensajeLimitesIguales(true);
                                        }
                                    }} />
                            </div>
                            <div className="col-xs-6">
                                <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary"
                                    onClick={() => { this.props.cambiarModoEdicion(false) }} />
                            </div>
                        </div>
                        {this.state.mensajeError == true &&
                            <div className="row">
                                <div className="col-xs-12">
                                    <label className="error">Ha excedido el limite de compra</label>
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default TableRowEdit;